<template>
  <div
    class="py-2"
  >
    <b-row>
      <b-col sm="12" class="mb-3">
        <label class="form-label small fw-bold">With Transaction</label>
        <validation-provider
          rules="check-date"
          v-slot="validationContext"
        >
          <input
            type="hidden"
            :state="getValidationState(validationContext)"
            v-model="wwoTransPassed" />
          <b-form-select
            class="form-control"
            :class="{'is-invalid': getValidationState(validationContext) === false }"
            v-model="setting.transactionQualifier"
            :options="behavioralOptions"
            @change="checkDateRange"
          />
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row class="mb-3" v-if="setting.transactionQualifier == 'r'">
      <b-col>
        <validation-provider
          name="date range"
          :rules="ruleObject"
          v-slot="validationContext"
        >
          <flat-pickr
            :class="{
              'is-invalid': getValidationState(validationContext) === false,
            }"
            v-model="setting.transactionRange"
            :config="rangeOptions"
            placeholder="Select a date range"
            class="form-control w-100"
            @on-change="checkDateRange"
          ></flat-pickr>
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row v-if="setting.transactionQualifier != 'd'" class="mx-2">
      <b-col sm="12" class="mb-3" v-if="propertyExist(setting,'transactionMops')">
        <label class="form-label small fw-bold" 
          >Mode of Payment</label
        >
        <validation-provider
          name="transactionMops"
          rules="required"
          v-slot="{ errors, ariaMsg }"
        >
          <multiselect 
            v-model="setting.transactionMops" 
            placeholder="Select Mode of Payment" 
            label="displayName" 
            track-by="name" 
            :options="mopOptions2" 
            :multiple="true"
            :allow-empty="true"
            :preselect-first="false"
            :class="{
              invalid: errors[0],
            }">
          </multiselect>
          <b-form-invalid-feedback v-bind="ariaMsg">
            {{ errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </b-col>
      <b-col sm="12" class="mb-3 row">
        <label class="form-label small fw-bold col-5">
          <div class="me-3">Transaction Count</div> 
        </label>
        <div class="col-1">
          <toggle-button
            :height="20"
            :width="40"
            v-model="setting.hasTransactionCount"
            color="#e73092"
            :sync="true"
          />
        </div>
        <div class="d-flex" v-if="setting.hasTransactionCount">
          <div :class="{'w-50 me-2':setting.transactionCountCondition != 'r', 'w-25 me-3':setting.transactionCountCondition == 'r'}">
            <b-form-select
              v-model="
                setting.transactionCountCondition
              "
              class="form-control"
              :options="conditionOptions"
            />
          </div>
          <template
            v-if="
              setting.transactionCountCondition != 'r'
            "
          >
            <validation-provider
              name="count"
              :rules="ruleObject2"
              v-slot="validationContext" 
              class="w-50"
            >
              <b-form-input
                :class="{
                  'is-invalid':
                    getValidationState(validationContext) === false,
                }"
                v-model="setting.transactionCount"
                type="number"
                step="0"
                class="form-control"
                placeholder="0"
                min="0"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </template>

          <template
            v-if="
              setting.transactionCountCondition == 'r'
            "
          >
            <validation-provider
              name="minimum value"
              :rules="ruleObject2"
              v-slot="validationContext"
            >
              <b-form-input
                :class="{
                  'is-invalid':
                    getValidationState(validationContext) === false,
                }"
                v-model="setting.transactionMinCount"
                type="number"
                step="0"
                class="form-control"
                placeholder="Minimum value"
                min="0"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
            <div class="p-2 ps-3 ps-3">to</div>
            <validation-provider
              name="maximum value"
              :rules="{
                required: true,
                min_value: setting.transactionMinCount
              }"
              v-slot="validationContext"
            >
              <b-form-input
                :class="{
                  'is-invalid':
                    getValidationState(validationContext) === false,
                }"
                v-model="setting.transactionMaxCount"
                type="number"
                step="0"
                class="form-control"
                placeholder="Maximum value"
                min="0"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </template>
        </div>
      </b-col>
      <b-col sm="12" class="mb-3 row">
        <label class="form-label small fw-bold col-5">
          <div class="me-3">Transaction Amount</div> 
        </label>
        <div class="col-1">
          <toggle-button
            :height="20"
            :width="40"
            v-model="setting.hasTransactionAmount"
            color="#e73092"
            :sync="true"
          />
        </div>
        <div class="d-flex" v-if="setting.hasTransactionAmount">
          <div :class="{'w-50 me-2':setting.transactionAmountCondition != 'r', 'w-25 me-3':setting.transactionAmountCondition == 'r'}">
            <b-form-select
              v-model="
                setting.transactionAmountCondition
              "
              class="form-control"
              :options="conditionOptions"
            />
          </div>
          <template
            v-if="
              setting.transactionAmountCondition != 'r'
            "
          >
            <validation-provider
              name="amount"
              :rules="ruleObject2"
              v-slot="validationContext"
              class="w-50"
            >
              <b-form-input
                :class="{
                  'is-invalid':
                    getValidationState(validationContext) === false,
                }"
                v-model="setting.transactionAmount"
                type="number"
                step="0"
                class=""
                placeholder="0"
                min="0"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </template>

          <template
            v-if="
              setting.transactionAmountCondition == 'r'
            "
          >
            <validation-provider
              name="minimum value"
              :rules="ruleObject2"
              v-slot="validationContext"
            >
              <b-form-input
                :class="{
                  'is-invalid':
                    getValidationState(validationContext) === false,
                }"
                v-model="setting.transactionMinAmount"
                type="number"
                step="0"
                class="form-control"
                placeholder="Minimum value"
                min="0"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
            <div class="p-2 ps-3 ps-3">to</div>
            <validation-provider
              name="maximum value"
              :rules="{
                required: true,
                min_value: setting.transactionMinAmount
              }"
              v-slot="validationContext"
            >
              <b-form-input
                :class="{
                  'is-invalid':
                    getValidationState(validationContext) === false,
                }"
                v-model="setting.transactionMaxAmount"
                type="number"
                step="0"
                class="form-control"
                placeholder="Maximum value"
                min="0"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </template>
        </div>
      </b-col>

        <b-col sm="12" class="mb-3 row" v-if="setting.hasTransactionAmount">
          <label class="form-label small fw-bold col-5">
            <div class="me-3">Transaction Grouping</div> 
          </label>
          <div class="d-flex">
            <b-form-select
              class="form-control"
              v-model="setting.transactionGrouping"
              :options="transactionGroupOptions"
            />
          </div>
        </b-col>

      <template v-if="setting.hasTransactionCount || setting.hasTransactionAmount">
        <b-col sm="12" class="mb-3 row" v-if="type == 'kankolek'">
          <label class="form-label small fw-bold col-5">
            <div class="me-3">Transaction Type</div> 
          </label>
          <div class="d-flex">
              <multiselect 
                v-model="kankolekTypes" 
                placeholder="Select transaction type" 
                label="text" 
                track-by="value" 
                :options="kankolekTransactionOptions" 
                :close-on-select="false"
                :multiple="true"
                :allow-empty="true"
                :preselect-first="false"
              >
              </multiselect>
          </div>
        </b-col>
      </template>
    </b-row>
    <b-row v-if="setting.transactionQualifier != 'd'">
    </b-row>
    <b-row>
      <b-col sm="12" class="mb-3">
        <label class="form-label small fw-bold">Without Transaction</label>
        <validation-provider
          rules="check-date"
          v-slot="validationContext"
        >
          <input
            type="hidden"
            :state="getValidationState(validationContext)"
            v-model="wwoTransPassed" />
          <b-form-select
            class="form-control"
            :class="{'is-invalid': getValidationState(validationContext) === false }"
            v-model="setting.woTransactionQualifier"
            :options="behavioralOptions"
            @change="checkDateRange"
          />
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row
      class="mb-3"
      v-if="setting.woTransactionQualifier == 'r'"
    >
      <b-col>
        <validation-provider
          name="date range"
          :rules="ruleObject"
          v-slot="validationContext"
        >
          <flat-pickr
            :class="{
              'is-invalid': getValidationState(validationContext) === false,
            }"
            v-model="setting.woTransactionRange"
            :config="rangeOptions"
            placeholder="Select a date range"
            class="form-control w-100"
            @on-change="checkDateRange"
          ></flat-pickr>
          <b-form-invalid-feedback>
            {{ validationContext.errors[0] }}
          </b-form-invalid-feedback>
        </validation-provider>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { ToggleButton } from 'vue-js-toggle-button';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { extend } from 'vee-validate';
import Multiselect from 'vue-multiselect'
import {mopComputed,mopMethods} from '@/state/helpers';

extend('check-date', {
  message: 'Transaction and w/out transaction dates are with conflict.',
  validate(value){
    return value === 'passed';
  }
});
 
const moment = extendMoment(Moment);

export default {
  name: 'setting-box',
  watch: {
    setting: {
      handler(val){
        this.$emit('update', val);
      },
      deep: true
    }
  },
  components: {
    flatPickr,
    ToggleButton,
    Multiselect
  },
  props: ['value','type'],
  data(){
    return {
      setting: this.value,
      wwoTransPassed: 'passed',
      rangeOptions: {
        mode: "range",
      },
      ruleObject: {
        required: true
      },
      ruleObject2: {
        required: true,
        min_value:0
      },
      conditionOptions: [
        {text: 'greater than', value: 'gt'},
        {text: 'greater than or equal', value: 'gte'},
        {text: 'less than', value: 'lt'},
        {text: 'less than or equal', value: 'lte'},
        {text: 'equal to', value: 'eq'},
        {text: 'range', value: 'r'}
      ],
      behavioralOptions: [
        {text: 'Disabled', value: 'd'},
        {text: 'All time', value: '0'},
        {text: '1 month ago', value: '1'},
        {text: '2 months ago', value: '2'},
        {text: '3 months ago', value: '3'},
        {text: 'Date Range', value: 'r'}
      ],
      transactionGroupOptions: [
        {text: 'Individual Transactions', value: 'individual'},
        {text: 'All Transactions', value: 'all'},
      ],
      kankolekTransactionOptions: [
        {text: 'P2P Send', value: 'send'},
        {text: 'P2P Receive', value: 'receive'},
        {text: 'QR P2M Send', value: 'qr_send'},
        {text: 'QR P2M Receive', value: 'qr_receive'},
        {text: 'Topup', value: 'topup'},
        {text: 'Claim Maricash', value: 'loan_maricash'},
        {text: 'Claim MK', value: 'mk_claimed'},
        {text: 'Maricash Payment', value: 'maricash_payment'}
      ],
      mopOptions2:[]
    }
  },
  methods: {
    ...mopMethods,
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    checkDateRange(){
      var wTranStart = null;
      var wTransEnd = null;
      var woTransStart = null;
      var woTransEnd = null;
      
      if(this.setting.transactionQualifier != 'd'){
        wTransEnd = moment();

        if(this.setting.transactionQualifier == '0'){
            wTranStart = moment('1970-01-01');
        } else if(this.setting.transactionQualifier == '1'){
            wTranStart = moment().subtract(1, 'months');
        } else if(this.setting.transactionQualifier == '2'){
            wTranStart = moment().subtract(2, 'months');
        } else if(this.setting.transactionQualifier == '3'){
            wTranStart = moment().subtract(3, 'months');
        } else if(this.setting.transactionQualifier == 'r'){
          if(this.setting.transactionRange){
            var dateOne = this.setting.transactionRange.split('to').map(d => d.trim());
            wTranStart = moment(dateOne[0]);
            wTransEnd = moment(dateOne[1]);
          }
        }
      }

      if(this.setting.woTransactionQualifier != 'd'){
        woTransEnd = moment();

        if(this.setting.woTransactionQualifier == '0'){
            woTransStart = moment('1970-01-01');
        } else if(this.setting.woTransactionQualifier == '1'){
            woTransStart = moment().subtract(1, 'months');
        } else if(this.setting.woTransactionQualifier == '2'){
            woTransStart = moment().subtract(2, 'months');
        } else if(this.setting.woTransactionQualifier == '3'){
            woTransStart = moment().subtract(3, 'months');
        } else if(this.setting.woTransactionQualifier == 'r'){
          if(this.setting.woTransactionRange){
            var dateTwo = this.setting.woTransactionRange.split('to').map(d => d.trim());
            woTransStart = moment(dateTwo[0]);
            woTransEnd = moment(dateTwo[1]);
          }
        }
      }

      if(this.setting.woTransactionQualifier == this.setting.transactionQualifier && 
        this.setting.woTransactionQualifier != 'r' && 
        this.setting.transactionQualifier != 'r' && 
        this.setting.transactionQualifier != 'd' && 
        this.setting.woTransactionQualifier != 'd'){
          this.wwoTransPassed = 'failed';
      } else {
        this.wwoTransPassed = 'passed';
        if(wTranStart && wTransEnd && woTransStart && woTransEnd){
          var transRange = moment.range(wTranStart.toDate(), wTransEnd.toDate());
          var woTransRange = moment.range(woTransStart.toDate(), woTransEnd.toDate());

          if(transRange.overlaps(woTransRange)){
            if(woTransStart.isSameOrBefore(wTranStart)){
              this.wwoTransPassed = 'failed';
            } else {
              this.wwoTransPassed = 'passed';
            }
          } else {
            this.wwoTransPassed = 'passed';
          } 
        }
      }
    },
    propertyExist(obj,prop){
      return Object.prototype.hasOwnProperty.call(obj, prop)
    }
  },
  computed: {
    ...mopComputed,
    kankolekTypes: {
      get(){
        return this.kankolekTransactionOptions.filter((to) => {
          return this.setting.transactionType.includes(to.value);
        })
      },
      set(selectedOptions){
        console.log(selectedOptions);
        console.log(selectedOptions.map(so => so.value));
        this.setting.transactionType = selectedOptions.map(so => so.value);
      }
    }
  },
  async mounted() {
    if(this.propertyExist(this.setting,'transactionMops')){
      await this.listMop({})
      .then(()=>{
        this.mopOptions2 = this.mops.map((m)=>{
          return {
                "name": m.name,
                "mopId": m.mopId,
                "displayName": m.displayName,
            }
        });
        //assign all mop by default
        if(this.setting.transactionMops.length == 0){
          this.setting.transactionMops = this.mopOptions2;
        }
      });
    }
  }
};
</script>

<style>
</style>